export const ACTION_TYPE = Object.freeze({
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
  CANCEL: 'CANCEL',
  REQUEST: 'REQUEST',
  UPDATE: 'UPDATE'
});

export const appointmentStatusInterval = 5000;
